import { h } from 'preact'
import { Modal, ModalBody, ModalFooter, ModalHeader } from '../modal'
import ButtonControl from '../button-control/index'

const SendTestEmailModal = ({ showModal, onClose }: { showModal: boolean, onClose: () => void }) => {
  return (
    <Modal isOpen={showModal} size='medium'>
      <ModalHeader title='Send test email' onClose={onClose} />
      <ModalBody>
        <p>A test email has been sent to your email address:</p>
        <strong>{window.inSidedData.user.email}</strong>
      </ModalBody>
      <ModalFooter>
        <ButtonControl
          title='Okay, got it'
          variant='brand'
          size='medium'
          newStyle
          onClick={onClose}
        />
      </ModalFooter>
    </Modal>
  )
}

export default SendTestEmailModal
